import {
    useMemo,
} from 'react'

import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
    getUrlsFromTableConfig, SkyNetDomainSubRoutes,
} from 'app/shared-components/SkyNetDomain'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import SkyNetDomainForm from 'app/shared-components/SkyNetDomain/SkyNetDomainForm'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

import useOrderManagementRoutes from 'app/SkyNetRoutes/hooks/useOrderManagementRoutes'
import {
    InternalTransportTabs,
} from 'app/enums/domain.enums'
import requests from 'app/requests/Order/Order.requests'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import useRouteStateFilter from 'app/hooks/useRouteStateFilter'

import ContainerSelection from '../Components/ContainerSelection/ContainerSelectionContainer'
import OrderSteps from '../Components/OrderSteps'
import OrderNotificationsTab from '../Components/OrderNotificationsTab'

import InternalTransportsOverview from './InternalTransportsOverview'
import getTableConfig from './internalTransport.config'
import CreateInternalTransportForm from './CreateInternalTransportForm'
import InternalOrdersChangeHistory from './InternalOrdersChangeHistory'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const InternalTransport = () => {
    const {
        InternalOrders: InternalOrdersRoutes,
    } = useOrderManagementRoutes()

    const {
        filter, clearFilterState,
    } = useRouteStateFilter()

    const tabs: SidebarTab[] = [
        {
            url: CommonRoutes.Overview,
            label: 'Overview',
            Component: InternalTransportsOverview,
        },
        {
            url: InternalTransportTabs.Notifications,
            label: 'Notifications',
            Component: OrderNotificationsTab,
        },
        {
            url: InternalTransportTabs.ContainerSelection,
            label: 'Containers / Freight',
            Component: ContainerSelection,
        },
        {
            url: InternalTransportTabs.OrderSteps,
            label: 'Order Steps',
            Component: OrderSteps,
        },
        {
            url: CommonRoutes.ChangeHistory,
            label: 'Change History',
            Component: InternalOrdersChangeHistory,
        },
    ]

    const customRoutes = useMemo(() => {
        return [{
            path: SkyNetDomainSubRoutes.CREATE,
            element: (
                <SkyNetDomainForm onClose={() => {
                    InternalOrdersRoutes.navigate()
                }}
                >
                    <CreateInternalTransportForm />
                </SkyNetDomainForm>
            ),
        }]
    }, [InternalOrdersRoutes])

    const tableConfig = useMemo(() => {
        return getTableConfig()
    }, [])

    return (
        <SkyNetDomain
            name="OrderView"
            sidebarTabs={tabs}
            uniqField="orderNumber"
            getDomainObject={requests.getOrderById}
            domainRequestKey={RequestKeys.getOrderByNumber}
            customRoutes={customRoutes}
            subdomainUrls={getUrlsFromTableConfig(tableConfig)}
        >
            <SkyNetTable
                moduleName="Order"
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
                filter={filter}
                clearFilterState={clearFilterState}
            />
        </SkyNetDomain>
    )
}

export default InternalTransport
